// update state
const setUserAction = (payload) => {
    return {
        type: "USER",
        payload
    }

}

export default setUserAction;




// WEBPACK FOOTER //
// ./src/actions/setUserAction.js